export default "__VITE_ASSET__aaGCurB7__"